module.exports = __webpack_public_path__ + "static/media/pause-24px.16c9e14c.svg";